import { Button, Tooltip } from '@octopus-do/octopus-storybook'
import { Refresh } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  crawling: boolean
  onClick: () => void
}

// Starts a crawl of the site the report is built from. While one is running the
// button is dead: the crawl is stopped from the progress panel that takes the
// counters' place, not from here.
export const UpdateButton: React.FC<Props> = ({ crawling, onClick }) => (
  <Tooltip label="Recrawl now">
    <Button
      priority="secondary"
      size="medium"
      left={Refresh}
      aria-label="Recrawl now"
      disabled={crawling}
      onClick={onClick}
    />
  </Tooltip>
)
